<template>
  <DetailsAsideLayout>
    <template v-slot:detailsContent>
      <CreateSystem
        :copyWell="copyWell"
        :showInstallerNotes="true"
        title="Puppet"
      >
        <template v-slot:instructions>
          <p>
            The following manifest can be used to install the agent onto a Puppet-managed server:
          </p>
        </template>
      </CreateSystem>
    </template>
  </DetailsAsideLayout>
</template>
<script>
import CreateSystem from 'client/systems/CreateSystem.vue';
import CreateSystemMixin from 'client/systems/CreateSystemMixin';
import DetailsAsideLayout from 'client/components/AsidePanel/Details/DetailsAsideLayout.vue';

export default {
  name: 'CreatePuppetSystem',

  components: {
    CreateSystem,
    DetailsAsideLayout,
  },

  mixins: [
    CreateSystemMixin,
  ],

  computed: {
    copyWell() {
      return this.copyWellPuppet;
    },
  },
};
</script>
